import { render, staticRenderFns } from "./WellComparison.vue?vue&type=template&id=b1c39f0a"
import script from "./WellComparison.vue?vue&type=script&lang=js"
export * from "./WellComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports